import { isTeamLeaderSpawnKey, isTeamSpawnKey } from "@rakazo/contracts";

/** Team bots live inside their group, so the sidebar shows the team instead of each member. */
export function isTeamBot(bot: { spawnKey: string | null }): boolean {
  return isTeamSpawnKey(bot.spawnKey);
}

/** The one member each preset team marks as its leader; its private chat is the management channel. */
export function isTeamLeader(spawnKey: string | null | undefined): boolean {
  return isTeamLeaderSpawnKey(spawnKey);
}
